import { toLocalDateTime2fafgh396r2y5 as toLocalDateTime } from './TimeZone.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function todayIn(_this__u8e3s4, timeZone) {
  return toLocalDateTime(_this__u8e3s4.now_2cba_k$(), timeZone).date_1;
}
//region block: exports
export {
  todayIn as todayIn1xeyw1nmvf0b4,
};
//endregion

//# sourceMappingURL=Clock.mjs.map
